import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../services/user.service';
import {NotificationService} from '../../services/notification.service';
import {MessageService} from '../../services/message.service';

import {NestasToolbarComponent} from '../toolbar/toolbar.component';

/*
*** Made to be used inside a modal (Or at least inside a MdCard)
*/
@Component({
  selector: 'message-admin',
  templateUrl: './message-admin.component.html',
  styleUrls: ['./message-admin.component.scss']
})
export class MessageAdminComponent implements OnInit{
  @Input() toEmail:String;
  @Output() done = new EventEmitter<Boolean>();
  fromEmail: String;
  subject:String;
  content:String;

  constructor(public translate: TranslateService, private _userService: UserService, private _notification: NotificationService,
  private _messageService: MessageService){

  }

  ngOnInit(){
    this.fromEmail = this._userService.me()['email'];
  }

  stopEvent(e){
    e.stopPropagation();
    e.preventDefault();
    return false;
  }

  sendMail(){
    this._messageService.sendMail({to: this.toEmail, from: this.fromEmail, subject: this.subject, content: this.content})
      .subscribe(() => {
        this._notification.info('CONTACT.SENT');
        this.subject = "";
        this.content = "";
        this.done.emit(true);
      }, err => { this._notification.errorServer(err); });
  }
}
